const initializeListeners = (ifvisible, sendDelayedMessage) => {
  const idleHandler = () => sendDelayedMessage({ type: "wentIdle" });
  const wakeUpHandler = () => sendDelayedMessage({ type: "wokeUp" });

  if (ifvisible) {
    ifvisible.setIdleDuration(60);
    ifvisible.on("idle", idleHandler);
    ifvisible.on("wakeup", wakeUpHandler);
  }

  const clickHandler = ({ type, screenX, screenY }) => {
    sendDelayedMessage({ type, screenX, screenY });
  };
  const keyDownHandler = ({ type }) => {
    sendDelayedMessage({ type });
  };

  window.addEventListener("click", clickHandler);
  window.addEventListener("keydown", keyDownHandler);

  return () => {
    if (ifvisible) {
      ifvisible.off("idle", idleHandler);
      ifvisible.off("wakeup", wakeUpHandler);
    }

    window.removeEventListener("click", clickHandler);
    window.removeEventListener("keydown", keyDownHandler);
  };
};

export default initializeListeners;
